module.exports = __webpack_public_path__ + "img/iconyue.341418c6.png";